import Icons, { IconsProps } from '../../Icons';

export type SellFilledProps = IconsProps;

export function SellFilled(props: SellFilledProps) {
  return (
    <Icons {...props}>
      <path d="M13.5558 20.7C13.3724 20.9 13.1391 21 12.8558 21C12.5724 21 12.3308 20.9 12.1308 20.7L3.33077 11.9C3.23077 11.8 3.15177 11.6873 3.09377 11.562C3.0351 11.4373 3.00577 11.3 3.00577 11.15V4C3.00577 3.73333 3.10577 3.5 3.30577 3.3C3.50577 3.1 3.7391 3 4.00577 3H11.1558C11.2891 3 11.4184 3.025 11.5438 3.075C11.6684 3.125 11.7808 3.2 11.8808 3.3L20.6808 12.1C20.8808 12.3 20.9851 12.5457 20.9938 12.837C21.0018 13.129 20.9058 13.3667 20.7058 13.55L13.5558 20.7ZM6.50577 7.5C6.7891 7.5 7.02677 7.40433 7.21877 7.213C7.4101 7.021 7.50577 6.78333 7.50577 6.5C7.50577 6.21667 7.4101 5.979 7.21877 5.787C7.02677 5.59567 6.7891 5.5 6.50577 5.5C6.22243 5.5 5.98477 5.59567 5.79277 5.787C5.60143 5.979 5.50577 6.21667 5.50577 6.5C5.50577 6.78333 5.60143 7.021 5.79277 7.213C5.98477 7.40433 6.22243 7.5 6.50577 7.5Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
